import { ExportIcon, PrintIcon } from "@xola/icons";
import { Button, Modal } from "@xola/ui-kit";
import React from "react";
import { Event, Purchase, PurchaseItem } from "types";
import { useResource } from "../../hooks/useResource";
import { PurchaseNoteList } from "../Common/NoteList";
import { SecondaryButton } from "../Common/SecondaryButton";
import { EventSummaryTile } from "../Event/EventSummaryTile";

interface PurchaseNotesModalProps {
    purchase: Purchase;
    purchaseItem?: PurchaseItem;
    onClose: () => void;
    isOpen: boolean;
}

export const PurchaseNotesModal = ({ purchase, purchaseItem, onClose, isOpen }: PurchaseNotesModalProps) => {
    return (
        <Modal isOpen={isOpen} size="huge" onClose={onClose}>
            <ModalContent purchaseItem={purchaseItem} purchase={purchase} onClose={onClose} />
        </Modal>
    );
};

interface ModalContentProps {
    purchase: Purchase;
    purchaseItem?: PurchaseItem;
    onClose: () => void;
}

const ModalContent = ({ purchase, purchaseItem, onClose }: ModalContentProps) => {
    return (
        <>
            <Modal.Header>
                <div className="flex items-center">
                    <span className="w-1/3" />
                    <span className="w-1/3">Notes</span>
                    {/* hiding as part of the X2-6792 requirements, since Print and Export are disabled permanently */}
                    <div className="flex hidden w-1/3 justify-end space-x-2">
                        <SecondaryButton disabled size="small" icon={<PrintIcon />}>
                            Print
                        </SecondaryButton>
                        <SecondaryButton disabled size="small" icon={<ExportIcon />}>
                            Export
                        </SecondaryButton>
                    </div>
                </div>
            </Modal.Header>

            <Modal.Body>
                <>
                    {purchaseItem?.event?.id ? <PurchaseItemEventSummary purchaseItem={purchaseItem} /> : null}
                    {purchase?.notes?.length > 0 ? (
                        <div className="mt-1">
                            <p className="mb-4 text-md font-bold leading-p1 text-black">Purchase Notes</p>
                            <PurchaseNoteList purchase={purchase} />
                        </div>
                    ) : null}
                </>
            </Modal.Body>

            <Modal.Footer className="space-x-4">
                <Button color="primary" onClick={onClose}>
                    Close
                </Button>
            </Modal.Footer>
        </>
    );
};

const PurchaseItemEventSummary = ({ purchaseItem }: { purchaseItem: PurchaseItem }) => {
    const eventId = purchaseItem.event.id;
    const { data: event } = useResource<Event>(["events", eventId]);

    return event ? <EventSummaryTile event={event} /> : null;
};
